import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  static values = {
    activeTab: { type: String, default: "" },
    reviewStyle: { type: Boolean, default: false },
  };

  connect() {
    if (!this.activeTabValue && this.tabTargets.length > 0) {
      this.activeTabValue = this.tabTargets[0].dataset.tabId;
    }

    this.sync();
  }

  selectTab(event) {
    const tabId = event.currentTarget.dataset.tabId;
    if (!tabId || tabId === this.activeTabValue) return;

    this.activeTabValue = tabId;
    this.sync();
  }

  sync() {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabId === this.activeTabValue;
      const declined = tab.dataset.declined === "true";
      tab.setAttribute("aria-selected", active ? "true" : "false");

      if (this.reviewStyleValue) {
        tab.classList.toggle("bg-white", active);
        tab.classList.toggle("shadow-sm", active);
        tab.classList.toggle("ring-1", active);
        tab.classList.toggle("ring-gray-modern-200", active);
        tab.classList.toggle("text-brand-700", active);
        tab.classList.toggle("text-gray-modern-600", !active);
      } else {
        tab.classList.toggle("bg-gray-modern-25", active);
        tab.classList.toggle("text-brand-700", active);
        tab.classList.toggle("text-brand-50", !active);
      }

      tab.classList.toggle("opacity-50", declined && !active);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tabId !== this.activeTabValue);
    });
  }
}
